import { useQuery } from '@tanstack/react-query'

import { parentApi } from '~/@common/api/parentApi'

/**
 * 학습지 난이도별 통계 (학부모 리포트).
 * studentId / worksheetId 둘 다 truthy 일 때만 fetch — 학부모 컨텍스트가 아니거나 학습지 미로드면 enabled false.
 */
export const useWorksheetDifficultyStatistics = (
  studentId: string | null | undefined,
  worksheetId: number | null | undefined,
) =>
  useQuery({
    queryKey: ['worksheet-difficulty-statistics', studentId, worksheetId],
    queryFn: () =>
      parentApi.getWorksheetDifficultyStatistics(studentId as string, worksheetId as number),
    enabled: !!studentId && !!worksheetId,
  })

/**
 * 학습지 보충학습 필요 단원 (학부모 리포트).
 */
export const useWorksheetSupplementaryLearning = (
  studentId: string | null | undefined,
  worksheetId: number | null | undefined,
) =>
  useQuery({
    queryKey: ['worksheet-supplementary-learning', studentId, worksheetId],
    queryFn: () =>
      parentApi.getWorksheetSupplementaryLearning(studentId as string, worksheetId as number),
    enabled: !!studentId && !!worksheetId,
  })

/**
 * 교재 난이도별 통계 (학부모 리포트) — 페이지 단위 progressId.
 */
export const useWorkbookDifficultyStatistics = (progressId: number | null | undefined) =>
  useQuery({
    queryKey: ['workbook-difficulty-statistics', progressId],
    queryFn: () => parentApi.getWorkbookDifficultyStatistics(progressId as number),
    enabled: !!progressId,
  })

/**
 * 교재 보충학습 필요 단원 (학부모 리포트) — 페이지 단위 progressId.
 */
export const useWorkbookSupplementaryLearning = (progressId: number | null | undefined) =>
  useQuery({
    queryKey: ['workbook-supplementary-learning', progressId],
    queryFn: () => parentApi.getWorkbookSupplementaryLearning(progressId as number),
    enabled: !!progressId,
  })
